import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import ContactForm from './ContactForm';

const { FiX, FiHeart } = FiIcons;

const BookingModal = ({ isOpen, onClose, serviceTitle }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-md flex items-center justify-center p-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, y: 20, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.9, y: 20, opacity: 0 }}
            className="bg-white rounded-[2.5rem] w-full max-w-2xl overflow-hidden shadow-2xl relative"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="absolute top-6 right-6 z-10">
              <button 
                onClick={onClose}
                className="p-2 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors"
              >
                <SafeIcon icon={FiX} className="w-6 h-6 text-gray-500" />
              </button>
            </div>

            <div className="p-8 md:p-12">
              <div className="flex items-center space-x-3 mb-6">
                <div className="p-3 bg-rose-100 rounded-2xl">
                  <SafeIcon icon={FiHeart} className="w-6 h-6 text-rose-500" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800">Book Experience</h2>
                  <p className="text-sm text-gray-500">Inquire about: <span className="text-rose-500 font-bold">{serviceTitle}</span></p>
                </div>
              </div>

              <ContactForm 
                preselectedInterest={serviceTitle} 
                onSuccess={() => setTimeout(onClose, 2000)}
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BookingModal;